import { useEffect, useState } from 'react';

import { isValid } from 'date-fns';
import { DatePicker } from '@mui/x-date-pickers';
import intl from 'components/i18n/ReactIntlWrapper';

type DatePickerDialogProps = {
  selected: Date | string;
  setSelected: Function;
  className: string;
  inputName: string;
  required: boolean;
  disabled: boolean;
  error?: boolean;
  helperText?: string;
};

export default function DatePickerDialog({
  selected,
  setSelected,
  className,
  inputName,
  required,
  disabled,
  error,
  helperText,
}: DatePickerDialogProps) {
  // Initialize with the selected value or null, but keep it consistent
  const [valueDate, setValueDate] = useState<Date | null>(() => {
    if (selected == null || selected == undefined || selected == '') {
      return null;
    }
    if (typeof selected === 'string') {
      const date = new Date(selected);
      return isValid(date) ? date : null;
    }
    if (selected instanceof Date) {
      return isValid(selected) ? selected : null;
    }
    return null;
  });

  const handleDaySelect = (date: Date | null) => {
    if (date !== null) {
      // Convert to ISO string for consistent parsing
      const isoString = date.toISOString();
      setSelected(isoString);
    }
  };

  useEffect(() => {
    let newDate: Date | null = null;
    
    if (selected == null || selected == undefined || selected == '') {
      newDate = null;
    }
    //if selected date is String
    else if (typeof selected === 'string') {
      //USE DATE-FNS
      const date = new Date(selected);
      newDate = isValid(date) ? date : null;
    }
    // if selectedDate as a Date instance
    else if (selected instanceof Date) {
      newDate = isValid(selected) ? selected : null;
    }
    
    // Only update if the value actually changed
    if (newDate?.getTime() !== valueDate?.getTime()) {
      setValueDate(newDate);
    }
  }, [selected, valueDate]);

  return (
    <DatePicker
      value={valueDate}
      onChange={(date) => {
        handleDaySelect(date as Date);
      }}
      format={'P'}
      disabled={disabled}
      name={inputName}
      className={className}
      slotProps={{
        textField: {
          size: 'small',
          className: 'w-100',
          placeholder: intl.get('datePicker.dateFormat'),
          InputProps: {
            required: required,
          },
          error,
          helperText,
        },
      }}
    />
  );
}
